define(['jquery'], function ($) {
	var ResponsiveTable = function () {
		var self = this;

		self.$ervBody = $('#erv-body');

		self.setupDeconstructed = function ($containers) {
			if (typeof ($containers) === 'undefined' || $containers.length === 0) {
				return;
			}

			$containers.each(function() {
				var $tablesContainer = $(this),
					$table = $tablesContainer.find('table').first();

				if ($table) {
					$table.addClass('deconstructed');
					$table.removeClass('wide-table');
					self.setSelectedColumn($table);
					self.setControlDots($tablesContainer);
				}

				self.simpleSwipeDetection($tablesContainer);
			});

			self.addEventListeners($containers);
		};

		self.setControlDots = function ($tablesContainer) {
			var $table = $tablesContainer.find('table'),
				$controls = $tablesContainer.find('.table-compare-control');

			if ($table.data('colspan') == 2) {
				$controls.addClass('hide');
				return;
			} else {
				$controls.removeClass('hide');
			}

			var	$controlDotsContainer = $tablesContainer.find('.table-compare-nav-counter'),
				$lis = $controlDotsContainer.find('li'),
				selectedIndex = self.getSelectedIndex($table);

			if ($lis.length === 0) {
				$table.find('thead th.compare-check-heading').each(function (index) {
					$controlDotsContainer.append('<li'+ (index === selectedIndex ? ' class="selected"' : '' ) +'>'+index+'</li>');
				});
			} else {
				$lis.removeClass('selected');
				$lis.each(function (index) {
					var $li = $(this);

					if (index === selectedIndex) {
						$li.addClass('selected');
					}
				});
			}
		}

		self.getSelectedIndex = function ($table) {
			var selectedIndex = 0;

			if ($table.find('thead th.selected').length) {
				$table.find('thead th').each(function (index) {
					if ($(this).hasClass('selected')) {
						selectedIndex = index-1;
					}
				});
			}

			return selectedIndex;
		};

		self.setSelectedColumn = function($table) {
			var $columnHeaders = $table.find('thead th.compare-check-heading'),
				columnSelected = self.getSelectedIndex($table),
				colspan = $table.data('colspan');

			$columnHeaders.addClass('hide');
			$columnHeaders.removeAttr('colspan');

			$columnHeaders.each(function (index) {
				var $heading = $(this);

				if (index === columnSelected) {
					$heading.attr('colspan', colspan);
					$heading.addClass('selected');
					$heading.removeClass('hide');
				} else {
					$heading.removeClass('selected');
				}
			});

			var $tableRows = $table.find('tbody tr');
			$tableRows.each(function () {
				var $row = $(this),
					$cells = $row.find('td');

				$cells.addClass('hide');

				$cells.each(function (index) {
					var $cell = $(this);

					if (columnSelected === index) {
						$cell.removeClass('hide');
					}
				});
			});
		}

		self.tearDownDeconstructed = function ($containers) {
			if (typeof ($containers) === 'undefined' || $containers.length === 0) {
				return;
			}

			$containers.each(function () {
				var $tablesContainer = $(this),
					$table = $tablesContainer.find('table').first();
				
				$table.find('td.hide, th.hide').removeClass('hide');

				if ($table.data('colspan') > 4) {
					$table.addClass('wide-table');
				} else {
					$table.removeClass('wide-table');
				}

				$table.removeAttr('colspan');
				$table.find('[colspan]').removeAttr('colspan');
				$table.removeClass('deconstructed');
			});

			self.removeEventListeners();
		};

		self.addEventListeners = function ($containers) {
			$containers.on('click', '[data-js="nav-button"]', function (e) {
				e.preventDefault();
				e.stopPropagation();

				var $button = $(this),
					$table = $button.parents('.table-compare-wrapper').find('table'),
					$headerColumns = $table.find('thead th.compare-check-heading'),
					$currentColumn = $table.find('thead th.compare-check-heading.selected'),
					$newSelectedColumn = null;

				if ($button.hasClass('next')) {
					$newSelectedColumn = $currentColumn.next('.compare-check-heading').attr('class') != undefined ? $currentColumn.next('.compare-check-heading') : $headerColumns.first();
				} else {
					$newSelectedColumn = $currentColumn.prev('.compare-check-heading').attr('class') != undefined ? $currentColumn.prev('.compare-check-heading') : $headerColumns.last();
				}

				$currentColumn.removeClass('selected');
				$newSelectedColumn.addClass('selected')

				self.setSelectedColumn($table);
				self.setControlDots($table.parent());
			});
		};

		self.removeEventListeners = function() {
			self.$ervBody.find('[data-js="nav-button"]').off();
			self.$ervBody.find('.table-compare-container').off();
		};

		self.simpleSwipeDetection = function ($el) {
			var el = $el[0],
				direction,
				startX,
				threshold = 100, //required min distance for swipe
				allowedTime = 200, // maximum time allowed to travel that distance
				startTime;

			var	handleSwipe = function (direction) {
				if (direction === 'left') {
					$el.find('[data-js="nav-button"].next').click();
				} else if (direction === 'right') {
					$el.find('[data-js="nav-button"].previous').click();
				}
			}

			el.addEventListener('touchstart', function(e) {
				var touchObj = e.changedTouches[0];
				direction = 'none';
				startX = touchObj.pageX;
				startTime = new Date().getTime(); // record time
			}, false);

			el.addEventListener('touchend', function(e) {
				var touchObj = e.changedTouches[0],
					distX = touchObj.pageX - startX,
					elapsedTime = new Date().getTime() - startTime; // get time elapsed

				if (elapsedTime <= allowedTime) {
					if (Math.abs(distX) >= threshold) {
						direction = (distX < 0) ? 'left' : 'right';
					}
				}

				handleSwipe(direction);
			}, false);
		}

		ResponsiveTable.prototype.initSmall = function ($containers) {
			var self = this;
			self.setupDeconstructed($containers);
		};

		ResponsiveTable.prototype.initLarger = function ($containers) {
			var self = this;
			self.tearDownDeconstructed($containers);
		};
	}

	return ResponsiveTable;
});